import { PlaceActionType } from './place-action-type';

export interface SetPlaceDescriptionAction {
  description: string;
  placeKey: string;
  type: PlaceActionType.SetPlaceDescription;
}

export const setPlaceDescription = (
  placeKey: string,
  description: string,
): SetPlaceDescriptionAction => ({
  description,
  placeKey,
  type: PlaceActionType.SetPlaceDescription,
});
